import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import cls from 'classnames';
import platform from 'platform';
import styles from './BrowserSupport.module.css';
const OK = 'ok';
const OUTDATED = 'outdated';
const UNSUPPORTED = 'unsupported';
function BrowserSupport() {
    const state = useMemo(() => {
        let version = 0;
        if (typeof platform.version === 'string') {
            const versionSplitted = platform.version.split('.');
            if (versionSplitted.length > 1) {
                version = +versionSplitted[0];
            }
        }
        let state = OK;
        switch (platform.name) {
            case 'IE':
                if (version === 11) {
                    state = OUTDATED;
                }
                else {
                    state = UNSUPPORTED;
                }
                break;
            case 'Chrome':
            case 'Chrome Mobile':
                if (version < 54) {
                    state = OUTDATED;
                }
                break;
            case 'Firefox':
                if (version < 52) {
                    state = OUTDATED;
                }
                break;
            case 'Microsoft Edge':
                break;
            case 'Safari':
                if (version < 10) {
                    state = OUTDATED;
                }
                break;
            case 'Opera':
                if (version < 43) {
                    state = OUTDATED;
                }
                break;
            default:
                break;
        }
        return state;
    }, []);
    const browserLinks = useMemo(() => {
        const links = [
            '<a target="_blank" href="https://www.google.ru/chrome/">Chrome</a>',
            '<a target="_blank" href="https://www.mozilla.org/firefox/new">Firefox</a>',
        ];
        if (platform.os?.family === 'Windows' ||
            platform.os?.family === 'Windows Server 2008 R2 / 7' ||
            platform.os?.family === 'Windows Server 2008 / Vista' ||
            platform.os?.family === 'Windows XP') {
            links.push('<a target="_blank" href="https://www.microsoft.com/microsoft-edge">Edge</a>');
        }
        else if (platform.os?.family === 'OS X') {
            links.push('<a target="_blank" href="https://www.apple.com/safari/">Safari</a>');
        }
        return `${links.slice(0, links.length - 1).join(', ')} or ${links[links.length - 1]}`;
    }, []);
    if (state === OK) {
        return null;
    }
    return (_jsxs("div", { className: cls(styles.browserSupport, {
            [styles.browserSupportOutdated]: state === OUTDATED,
            [styles.browserSupportUnsupported]: state === UNSUPPORTED,
        }), children: [_jsxs("p", { className: "bigger", children: [_jsx("span", { children: "Your browser " }), _jsx("span", { children: platform.name }), _jsx("span", { children: platform.version }), _jsx("span", { children: " is " }), _jsxs("span", { children: [state, "!"] })] }), state === OUTDATED && (_jsxs("p", { children: [_jsx("span", { children: "For a better experience, keep your browser up to date. Please use latest version of " }), _jsx("span", { dangerouslySetInnerHTML: { __html: browserLinks } })] })), state === UNSUPPORTED && (_jsxs("p", { children: [_jsx("span", { children: "Your browser is not fully supported. Please use latest version of " }), _jsx("span", { dangerouslySetInnerHTML: { __html: browserLinks } }), _jsx("span", { children: " browsers." })] }))] }));
}
export default memo(BrowserSupport);
